import updateUrlParam from './updateUrlParam';

const setUrlParameter = (name: string | number, value: string | number): void => {
  const params = new URLSearchParams(window.location.search);
  params.set(`${name}`, `${value}`);
  updateUrlParam(params);
};

export default setUrlParameter;
